import * as PIXI from 'pixi.js';
import TransformComponent from 'Component/Transform';
import GameObject from 'GameObject/GameObject';
import RopeComponent from 'Component/Render/Rope';
import AnimationComponent from 'Component/Animation';
import { TilingRope } from './TilingRope';
import { TILING_ROPE_CACHE_KEY } from './Level/Card/Modifier/Connected';
import Renderable from '../Component/Renderable';
import PIXIRenderer from 'System/Render/PIXIRenderer';

export default class Rope extends GameObject<TilingRope> {
    protected instantiateContainer(params: any): void {
        const texture = PIXIRenderer.getTexture(params.texture || TILING_ROPE_CACHE_KEY);
        this.container = new TilingRope(texture, params.points ?? [], params.downSample ?? 1);
        this.container.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
    }

    protected onCreate(params: any): void {
        this.addComponent(TransformComponent, params);
        this.addComponent(RopeComponent, params);
        this.addComponent(AnimationComponent, params);
        this.addComponent(Renderable, params);
    }
}
